var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B264F",
    d: "M28.043 5.802l2.121 2.121L8.951 29.136l-2.121-2.12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B264F",
    d: "M7.094 8.852L9.216 6.73l21.213 21.214-2.122 2.12z"
  })));
}
export default __webpack_public_path__ + "media/images/close-icon-118f4be8.svg";
export { SvgCloseIcon as ReactComponent };